import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { ActivatedRoute, Router } from '@angular/router';
import { LiveService } from 'src/app/services/live.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-live',
    templateUrl: './live.component.html',
    styleUrls: ['./live.component.css']
})
export class LiveComponent implements OnInit, OnDestroy {

    ivs: boolean = true;
    url: string;
    isWebAsmSupported = false;
    compat: string;
    livestreamId: number;

    showBack = false;
    backTimeout: any;

    @ViewChild('backButton') backButton;

    closeSub$: Subject<void> = new Subject<void>();

    constructor(
        private app: AppComponent,
        private router: Router,
        private liveService: LiveService,
        private route: ActivatedRoute,) {
    }

    ngOnInit() {
        const streamId = this.route.snapshot.paramMap.get('id');
        if (streamId) {
            this.livestreamId = +streamId;
        }

        this.liveService.status$.pipe(takeUntil(this.closeSub$)).subscribe(status => {
            if (!status) {
                return;
            }

            if (status.streams && status.streams.length > 0) {
                this.url = status.streams.find(x => x.livestreamId === this.livestreamId)?.url;
                if (!this.url) {
                    this.url = status.streams[0].url;
                }
                this.closeSub$.next();
            }
        });
        this.isWebAsmSupported = this.webAsmSupported();
        this.compat = this.isWebAsmSupported ? 'yes' : 'no';
    }

    ngOnDestroy() {
        this.closeSub$.next();
        this.closeSub$.complete();
    }

    returnToPreviousPage() {
        this.router.navigate(['/home']);
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: any) {

        switch(event.key) {
            case 'ArrowLeft':
            case 'ArrowRight':
            case 'ArrowUp':
            case 'ArrowDown':
                event.preventDefault()
                event.stopPropagation();
                this.backButton.nativeElement.focus();
                this.showBack = true;
                clearTimeout(this.backTimeout);
                this.backTimeout = setTimeout(() => {
                    this.showBack = false;
                }, 5000)
        }
    }

    webAsmSupported() {
        try {
            if (typeof WebAssembly === "object"
                && typeof WebAssembly.instantiate === "function") {
                const module = new WebAssembly.Module(Uint8Array.of(0x0, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00));
                if (module instanceof WebAssembly.Module)
                    return new WebAssembly.Instance(module) instanceof WebAssembly.Instance;
            }
        } catch (e) {
        }
        return false;
    };
}
